export { type DidCommMessageSendRequest } from './DidCommMessageSendRequest';
export { type DidcommMessageDeleteRequest } from './DidcommMessageDeleteRequest';
export { type DidcommMessageHistoryRequest } from './DidcommMessageHistoryRequest';
export { type DidcommMessageLatestRequest } from './DidcommMessageLatestRequest';
export { type DidcommMessageRestoreRequest } from './DidcommMessageRestoreRequest';
export { type DidcommMessageRevisionRequest } from './DidcommMessageRevisionRequest';
export { type DidcommMessageSearchRequest } from './DidcommMessageSearchRequest';
export { type DidcommMessageUpdateAnnotationsRequest } from './DidcommMessageUpdateAnnotationsRequest';
export { type DidcommMessageUpdateLabelsRequest } from './DidcommMessageUpdateLabelsRequest';
